module.exports = __webpack_public_path__ + "img/last_blank.9ebc0344.jpg";